import { render, staticRenderFns } from "./AssignmentBlock.vue?vue&type=template&id=e72d365c"
import script from "./AssignmentBlock.vue?vue&type=script&lang=js"
export * from "./AssignmentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports